import React, { Component } from "react";
import { Row, Col, Select, notification, Tooltip, Modal, Divider } from "antd";
import { connect } from "react-redux";
import axios from "axios";
import moment from "moment";
import {
  ModalItem,
  Form,
  FormItem,
  InputItem,
  SelectItem,
  ButtonItem,
  CheckItem,
  DatePickerItem,
} from "../../../../Components/Items";
import SelectContactosItem from "../../../../Components/SelectContactosItem";
import SelectEmbudosItem from "../../../../Components/SelectEmbudosItem";
import SelectInsumosItem from "../../../../Components/SelectInsumosItem";
import ModalContacto from "./ModalContacto";
import { UserAddOutlined } from "@ant-design/icons";

const { Option } = Select;

class ModalLead extends Component {
  formRef = React.createRef();

  state = {
    embudoActivoForm: null,
    etapasDelEmbudo: [],
    loading: false,
    fetchingData: false,
    contactoInyectado: null,
    modalContactoVisible: false,
    contactoSelectKey: 0,
    usuarios: [],
    camposPersonalizadosDisponibles: [],
    insumoInyectado: null,
  };

  componentDidMount() {
    this.cargarUsuarios();
    this.cargarCamposPersonalizados();
    if (this.props.visible) {
      this.cargarDatosIniciales();
    }
  }

  cargarCamposPersonalizados = () => {
    axios
      .post(
        "camposLead/camposLeadActivos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((r) => {
        if (r.data.success === 2) {
          this.setState({ camposPersonalizadosDisponibles: r.data.campos });
        }
      })
      .catch(() => {});
  };


  cargarUsuarios = () => {
    axios
      .post(
        "usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken },
      )
      .then((r) => {
        if (Array.isArray(r.data)) this.setState({ usuarios: r.data });
      })
      .catch(() => {});
  };

  componentDidUpdate(prevProps) {
    if (this.props.visible && !prevProps.visible) {
      this.cargarDatosIniciales();
    }
  }

  cargarDatosIniciales = () => {
    const {
      leadAEditar,
      contactoPreseleccionado,
      embudoSeleccionado,
      embudoSeleccionadoObjeto,
    } = this.props;

    if (leadAEditar) {
      this.fetchDatosLead(leadAEditar);
    } else {
      const etapasIniciales = embudoSeleccionadoObjeto?.etapas
        ? [...embudoSeleccionadoObjeto.etapas].sort((a, b) => a.orden - b.orden)
        : [];

      this.setState(
        {
          embudoActivoForm: embudoSeleccionado,
          etapasDelEmbudo: etapasIniciales,
        },
        () => {
          if (this.formRef.current) {
            this.formRef.current.resetFields();
            this.formRef.current.setFieldsValue({
              embudoId: embudoSeleccionado,
              contactoId: contactoPreseleccionado?._id,
            });
          }
        },
      );
    }
  };

  fetchDatosLead = (idLead) => {
    this.setState({ fetchingData: true });

    axios
      .post(
        "leads/datosLead",
        { id: idLead },
        { headers: this.props.headersToken },
      )
      .then((res) => {
        if (res.data.success === 2) {
          const lead = res.data.data;

          let inyectado = null;
          if (lead.contactoId) {
            const c = lead.contactoId;
            const nombreCompleto =
              `${c.nombre} ${c.apellidoPaterno} ${c.apellidoMaterno || ""}`.trim();
            inyectado = { _id: c._id, stringBuscar: nombreCompleto };
          }

          let insumoInyectado = null;
          if (lead.insumoBuscadoId) {
            const i = lead.insumoBuscadoId;
            const texto = i.clave ? `${i.clave} - ${i.descripcion}` : i.descripcion;
            insumoInyectado = { _id: i._id, stringBuscar: texto };
          }

          const camposPersonalizados = (lead.camposPersonalizados || []).reduce(
            (acc, dato) => {
              if (!dato.campoId) return acc;
              acc[dato.campoId] =
                dato.tipo === "date" && dato.valor
                  ? moment(dato.valor, "DD/MM/YYYY")
                  : dato.valor;
              return acc;
            },
            {},
          );

          this.setState(
            {
              embudoActivoForm: lead.embudoId?._id || lead.embudoId,
              etapasDelEmbudo: lead.embudoId?.etapas
                ? [...lead.embudoId.etapas].sort((a, b) => a.orden - b.orden)
                : [],
              contactoInyectado: inyectado,
              insumoInyectado,
            },
            () => {
              if (this.formRef.current) {
                this.formRef.current.setFieldsValue({
                  ...lead,
                  contactoId: lead.contactoId?._id || lead.contactoId,
                  embudoId: lead.embudoId?._id || lead.embudoId,
                  insumoBuscadoId: lead.insumoBuscadoId?._id || lead.insumoBuscadoId,
                  camposPersonalizados,
                });
              }
            },
          );
        } else {
          notification.error({ message: res.data.message });
          this.cerrarModal();
        }
      })
      .catch((err) => {
        console.error(err);
        notification.error({ message: "Error al cargar los datos del Lead." });
      })
      .finally(() => this.setState({ fetchingData: false }));
  };

  handleEmbudoChange = (id, embudoSeleccionado) => {
    const cambioReal = id !== this.state.embudoActivoForm;

    this.setState(
      {
        embudoActivoForm: id,
        etapasDelEmbudo: embudoSeleccionado?.etapas
          ? [...embudoSeleccionado.etapas].sort((a, b) => a.orden - b.orden)
          : [],
      },
      () => {
        if (cambioReal && this.formRef.current) {
          this.formRef.current.setFieldsValue({ etapaActualId: null });
        }
      },
    );
  };

  onFinish = (values) => {
    const camposPersonalizados = { ...(values.camposPersonalizados || {}) };
    Object.keys(camposPersonalizados).forEach((campoId) => {
      if (moment.isMoment(camposPersonalizados[campoId])) {
        camposPersonalizados[campoId] =
          camposPersonalizados[campoId].format("DD/MM/YYYY");
      }
    });

    this.enviarLead({ ...values, camposPersonalizados });
  };

  
  enviarLead = (values, resolverChat) => {
    this.setState({ loading: true });

    const payload = {
      ...values,
      _id: this.props.leadAEditar,
      empresaId: this.props.empresaId,
      chequearChat: true,
      ...(resolverChat && { resolverChat }),
    };

    axios
      .post("leads/guardarLead", payload, { headers: this.props.headersToken })
      .then((res) => {
        if (res.data.success === 2) {
          notification.success({
            message: "Lead guardado",
            description: "El lead ya está disponible en tu tablero.",
          });
          if (this.props.onSuccess) this.props.onSuccess();
          this.cerrarModal();
        } else if (res.data.success === 4) {
          this.preguntarReasignarWhatsapp(res.data.whatsappConflicto, values);
        } else {
          notification.error({ message: res.data.message });
        }
      })
      .catch((err) => {
        console.error(err);
        notification.error({ message: "Error al guardar el Lead." });
      })
      .finally(() => this.setState({ loading: false }));
  };

  preguntarReasignarWhatsapp = (conflicto, values) => {
    const nombreActual = conflicto?.asignadoActual?.nombre || "otro usuario";
    Modal.confirm({
      title: "Chat de WhatsApp ya asignado",
      content: `El chat de este contacto ya está asignado a ${nombreActual}. ¿Reasignarlo al dueño del lead (recomendado) o mantenerlo como está?`,
      okText: "Reasignar (recomendado)",
      cancelText: "Mantener",
      onOk: () => this.enviarLead(values, "reasignar"),
      onCancel: () => this.enviarLead(values, "mantener"),
    });
  };

  onContactoCreado = (nuevoContactoId) => {
    this.setState((prev) => ({
      modalContactoVisible: false,
      contactoSelectKey: prev.contactoSelectKey + 1,
    }));
    if (nuevoContactoId && this.formRef.current) {
      this.formRef.current.setFieldsValue({ contactoId: nuevoContactoId });
    }
  };

  cerrarModal = () => {
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
    this.setState({
      embudoActivoForm: null,
      etapasDelEmbudo: [],
      contactoInyectado: null,
      insumoInyectado: null,
      modalContactoVisible: false,
    });
    this.props.onCancel();
  };

  renderCampoPersonalizado = (campo) => {
    const layoutCampo = {
      labelCol: { span: 7 },
      wrapperCol: { span: 17 },
      style: { marginBottom: 10 },
    };

    if (campo.tipo === "boolean") {
      return (
        <FormItem
          key={campo._id}
          name={["camposPersonalizados", campo._id]}
          label={campo.nombre}
          valuePropName="checked"
          {...layoutCampo}
        >
          <CheckItem />
        </FormItem>
      );
    }

    if (campo.tipo === "date") {
      return (
        <FormItem
          key={campo._id}
          name={["camposPersonalizados", campo._id]}
          label={campo.nombre}
          {...layoutCampo}
        >
          <DatePickerItem />
        </FormItem>
      );
    }

    if (campo.tipo === "number") {
      return (
        <FormItem
          key={campo._id}
          name={["camposPersonalizados", campo._id]}
          label={campo.nombre}
          {...layoutCampo}
        >
          <InputItem type="number" />
        </FormItem>
      );
    }

    if (campo.tipo === "select") {
      return (
        <FormItem
          key={campo._id}
          name={["camposPersonalizados", campo._id]}
          label={campo.nombre}
          {...layoutCampo}
        >
          <SelectItem placeholder={`Selecciona ${campo.nombre}`} allowClear>
            {(campo.opciones || []).map((op) => (
              <Option key={op} value={op}>
                {op}
              </Option>
            ))}
          </SelectItem>
        </FormItem>
      );
    }

    return (
      <FormItem
        key={campo._id}
        name={["camposPersonalizados", campo._id]}
        label={campo.nombre}
        {...layoutCampo}
      >
        <InputItem />
      </FormItem>
    );
  };

  render() {
    const { visible, leadAEditar, headersToken, esMaster } = this.props;
    const {
      embudoActivoForm,
      etapasDelEmbudo,
      loading,
      fetchingData,
      contactoInyectado,
      modalContactoVisible,
      contactoSelectKey,
      insumoInyectado,
    } = this.state;

    return (
      <>
        {/* Mismo zIndex que este modal (no mayor, o los dropdowns de 1050 quedan detras): al abrirse despues queda encima */}
        <ModalContacto
          visible={modalContactoVisible}
          idContacto={null}
          zIndex={1050}
          onCancel={() => this.setState({ modalContactoVisible: false })}
          onSuccess={this.onContactoCreado}
        />

        <ModalItem
          title={leadAEditar ? "Editar Lead" : "Nuevo Lead"}
          visible={visible}
          onCancel={this.cerrarModal}
          spinning={fetchingData}
          width={900}
          zIndex={1050}
        >
          <Form
            ref={this.formRef}
            name="form_modal_lead"
            layout="vertical"
            onFinish={this.onFinish}
            bottom={
              <div style={{ display: "flex", justifyContent: "flex-end" }}>
                <ButtonItem
                  rojo
                  onClick={this.cerrarModal}
                  style={{ marginRight: 8 }}
                  disabled={loading}
                >
                  Cancelar
                </ButtonItem>
                <ButtonItem azul htmlType="submit" loading={loading}>
                  {leadAEditar ? "Guardar Cambios" : "Crear Lead"}
                </ButtonItem>
              </div>
            }
          >
            <Row gutter={16}>
              <Col span={12}>
                <FormItem
                  name="descripcion"
                  label="Descripción del Lead"
                  required
                  margin
                  wrapperCol={12}
                  labelCol={12}
                >
                  <InputItem placeholder="Ej: Preventa..." />
                </FormItem>

                <FormItem
                  label="Contacto Asociado"
                  required
                  margin
                  wrapperCol={12}
                  labelCol={12}
                >
                  <div
                    style={{
                      display: "flex",
                      gap: 8,
                      alignItems: "center",
                      minWidth: 0,
                    }}
                  >
                    <div style={{ flex: 1, minWidth: 0 }}>
                      <FormItem
                        name="contactoId"
                        noStyle
                        rules={[{ required: true, message: "El contacto es requerido." }]}
                      >
                        <SelectContactosItem
                          key={contactoSelectKey}
                          headersToken={headersToken}
                          empresaId={this.props.empresaId}
                          placeholder="Buscar contacto..."
                          width="100%"
                        >
                          {contactoInyectado && (
                            <Option
                              key={contactoInyectado._id}
                              value={contactoInyectado._id}
                            >
                              {contactoInyectado.stringBuscar}
                            </Option>
                          )}
                        </SelectContactosItem>
                      </FormItem>
                    </div>
                    <Tooltip title="Nuevo contacto">
                      <ButtonItem
                        icon={<UserAddOutlined />}
                        onClick={() => this.setState({ modalContactoVisible: true })}
                        style={{ flexShrink: 0 }}
                      />
                    </Tooltip>
                  </div>
                </FormItem>

                <FormItem
                  name="valor"
                  label="Valor Estimado ($)"
                  numberCero
                  margin
                  wrapperCol={12}
                  labelCol={12}
                >
                  <InputItem type="number" placeholder="0.00" />
                </FormItem>

                <FormItem
                  name="origen"
                  label="Origen del Lead"
                  margin
                  wrapperCol={12}
                  labelCol={12}
                >
                  <InputItem placeholder="Ej: Facebook, Recomendación..." />
                </FormItem>

                <FormItem
                  name="externalId"
                  label="ID Externo"
                  margin
                  wrapperCol={12}
                  labelCol={12}
                >
                  <InputItem placeholder="ID en sistema externo (opcional)" />
                </FormItem>

                {esMaster && (
                  <FormItem
                    name="usuarioId"
                    label="Asignar a"
                    margin
                    wrapperCol={12}
                    labelCol={12}
                  >
                    <SelectItem
                      placeholder="Usuario responsable (opcional)"
                      allowClear
                      showSearch
                      optionFilterProp="children"
                    >
                      {this.state.usuarios.map((u) => (
                        <Option key={u._id} value={u._id}>
                          {`${u.nombre} ${u.apellidoPaterno || ""}`.trim()}
                        </Option>
                      ))}
                    </SelectItem>
                  </FormItem>
                )}
              </Col>

              <Col span={12}>
                <FormItem
                  name="embudoId"
                  label="Embudo"
                  required
                  margin
                  wrapperCol={12}
                  labelCol={12}
                >
                  <SelectEmbudosItem
                    headersToken={headersToken}
                    empresaId={this.props.empresaId}
                    placeholder="Buscar embudo..."
                    width="100%"
                    onChange={this.handleEmbudoChange}
                  />
                </FormItem>

                <FormItem
                  name="etapaActualId"
                  label="Etapa Inicial"
                  required
                  margin
                  wrapperCol={12}
                  labelCol={12}
                >
                  <SelectItem
                    placeholder="Selecciona la etapa"
                    disabled={!embudoActivoForm}
                  >
                    {etapasDelEmbudo.map((etapa) => (
                      <Option key={etapa._id} value={etapa._id}>
                        {etapa.nombre}
                      </Option>
                    ))}
                  </SelectItem>
                </FormItem>

                <FormItem
                  name="numero"
                  label="Teléfono Directo "
                  margin
                  wrapperCol={12}
                  labelCol={12}
                >
                  <InputItem placeholder="Si es diferente al del contacto" />
                </FormItem>

                <FormItem
                  name="correo"
                  label="Correo Directo "
                  email
                  margin
                  wrapperCol={12}
                  labelCol={12}
                >
                  <InputItem placeholder="Si es diferente al del contacto" />
                </FormItem>

                <FormItem
                  name="insumoBuscadoId"
                  label="Insumo Buscado"
                  margin
                  wrapperCol={12}
                  labelCol={12}
                >
                  <SelectInsumosItem
                    headersToken={headersToken}
                    empresaId={this.props.empresaId}
                    tiposInsumos="venta"
                    insumoPreCargado={insumoInyectado}
                    placeholder="Buscar insumo..."
                    allowClear
                    width="100%"
                  />
                </FormItem>
              </Col>
            </Row>

            {this.state.camposPersonalizadosDisponibles.length > 0 && (
              <>
                <Divider style={{ margin: "12px 0" }} />
                <p style={{ color: "#5e6c84", fontSize: 13, marginBottom: 15 }}>
                  <b>Campos Personalizados</b>
                </p>
                <Row gutter={16}>
                  {this.state.camposPersonalizadosDisponibles.map((campo) => (
                    <Col span={24} key={campo._id}>
                      {this.renderCampoPersonalizado(campo)}
                    </Col>
                  ))}
                </Row>
              </>
            )}
          </Form>
        </ModalItem>
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};

export default connect(mapStateToProps)(ModalLead);
